import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './MainSideSummary.js';
import { RichText } from '@synergycms_core/components/generic';

import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';



const MainSideSummary = class MainSideSummary extends React.Component {
  static displayName = 'MainSideSummary';
  summaryList(listReservation) {
    var idx = 0;
    var list = [];
    listReservation.get('blocks').forEach(block => {
      var foundItem = list.find(item => item.id === block.get("id"));
      if (!foundItem) {
        list.push({
          idx: idx,
          name: block.get('name'),
          price: block.get('price'),
          priceUnit: block.get('price'),
          count: 1,
          id: block.get("id")
        });
        idx++;
      }
      else {
        foundItem.count++;
        foundItem.price += block.get('price');
      }
    });
    return list;
  };

  render() {
    const { config, theme } = this.props,
      {
        totalPrice,
        reservation
      } = config;
    const { classes } = theme.styles;
    const summaryBlocks = this.summaryList(reservation);
    return (
      <div className={theme.computedInnerStyle}>
        <div className={classes.header}>
          <RichText
            innerStyle={classes.modalTitle}
            ucFirst={true}
            text={'_%resumen de tu compra%_'}
            translate={true}
          />
        </div>
        <div className={classes.content}>
          <div className={[classes.contentModule, classes.roomModules].join(' ')}>
            {reservation.get("blocks") &&
              summaryBlocks.map(block => {
                return (
                  <div key={block.idx} className={classes.contentModuleRow}>
                    <div className={classes.contentModuleCell}>
                      <RichText text={block.name} innerStyle={['roboto13BoldBlack']} />
                      <br />
                      <RichText text={block.priceUnit + '€ (x' + block.count + ')'} innerStyle={['roboto13Black']} />
                    </div>
                    <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
                      <Price
                        innerStyle={['summaryPriceSmall']}
                        amount={block.price}
                        hotelCurrencyCode={"EUR"}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          <div className={[classes.contentModule, classes.finalPrice].join(' ')}>
            <div className={classes.contentModuleRow}>
              <div className={classes.contentModuleCell}>
                <RichText text={'precio total'} ucFirst={true} innerStyle={['roboto16BoldBlack']} translate={true} />
              </div>
              <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
                <Price
                  innerStyle={['summaryPriceBigModule']}
                  amount={totalPrice}
                  hotelCurrencyCode={"EUR"}
                />
              </div>
            </div>
            <div className={classes.contentModuleRow}>
              <div className={classes.contentModuleCell}>
                <RichText
                  text={'_%impuestos incluidos%_'}
                  innerStyle={['roboto11SoftGray400', 'taxesAvail']}
                  translate={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const reservation = store.getIn(["customer", "reservation_request"]);


  return {
    reservation,
    totalPrice: reservation.get("blocks").reduce((price, block) => {
      return price + parseFloat(block.get("price"));
    }, 0)
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'reservation',
    'totalPrice'
  ]),
  withThemeJSS({ styleFile })
)(MainSideSummary);
